// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "toast[name=neutral].--clickable{cursor:pointer}", "",{"version":3,"sources":["webpack://./src/partner-dashboard/toasts/neutral/neutral.scss"],"names":[],"mappings":"AAEC,gCAEC,cAAA","sourcesContent":["toast[name=\"neutral\"]\n{\n\t&.--clickable\n\t{\n\t\tcursor: pointer;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
